import OtpModal from './otp-modal.vue';

export default OtpModal;
